module.exports = __webpack_public_path__ + "static/bed1-5d8b1147ae3ecf0d06d524d1ee254dbe.jpg";